module.exports = __webpack_public_path__ + "img/IMG_9543_L_Black.44a82e05.jpg";